export * from './CoreModule'
export const corePath = '/et'
